import { zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

export const LedgerEntriesTableWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--lumen-spacing-12);
  height: 100%;
  min-height: 0;
`

export const LedgerEntriesToolbarSlot = styled.div`
  flex-shrink: 0;
`

export const LedgerEntriesTableScrollArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow-x: auto;
  overflow-y: hidden;

  > div {
    min-height: 0;
    max-height: 100%;
  }

  /* Lumen tints hover, selected and highlighted rows with the same token: only rows with a click action react to
     hover, and tinted (opening balance) rows step up to the hover token so their state stays visible.
     Lumen only exposes the highlighted state as a hashed class name. */
  tbody tr:not([role='button']):not([class*='rowHighlighted']):hover {
    background-color: transparent;
  }

  tbody tr[class*='rowHighlighted'][role='button']:hover,
  tbody tr[class*='rowHighlighted'][aria-current='true'] {
    background-color: var(--lumen-color-surface-neutral-subtle-hover);
  }

  tr[data-totals-row] td {
    position: sticky;
    bottom: 0;
    z-index: ${zIndex.TableStickyHeader};
    background-color: var(--lumen-color-surface-neutral-subtle-default);
    box-shadow: inset 0 1px 0 var(--lumen-color-border-neutral-subtle);
  }
`
